// @ commons
const { APIGet, APIPost } = require('utilities/APIRequestHelper');

// @ actions
const { requestMortgageData } = require('actions/mortgageRequest/mortgageRequestMortgageData');
const { requestState } = require('actions/mortgageRequest/mortgageRequestState');

// @ constants
const {
    MORTGAGE_REQUEST_MONTHLY_FEE_REQUEST,
    MORTGAGE_REQUEST_MOVING_FEE_SUCCESS,
    MORTGAGE_REQUEST_MOVING_FEE_FAILURE,
    MORTGAGE_REQUEST_ACCEPT_MOVING_FEE_REQUEST,
    MORTGAGE_REQUEST_ACCEPT_MOVING_FEE_SUCCESS,
    MORTGAGE_REQUEST_ACCEPT_MOVING_FEE_FAILURE
} = require('constants/actionTypes');

const requestMonthlyFeeInProgress = () => ({
    type: MORTGAGE_REQUEST_MONTHLY_FEE_REQUEST
});

const requestMonthlyFeeSuccess = data => ({
    type: MORTGAGE_REQUEST_MOVING_FEE_SUCCESS,
    data
});

const requestMonthlyFeeFailure = error => ({
    type: MORTGAGE_REQUEST_MOVING_FEE_FAILURE,
    data: {
        error
    }
});

const acceptMovingFeeInProgress = () => ({
    type: MORTGAGE_REQUEST_ACCEPT_MOVING_FEE_REQUEST
});

const acceptMovingFeeSuccess = data => ({
    type: MORTGAGE_REQUEST_ACCEPT_MOVING_FEE_SUCCESS,
    data
});

const acceptMovingFeeFailure = error => ({
    type: MORTGAGE_REQUEST_ACCEPT_MOVING_FEE_FAILURE,
    data: {
        error
    }
});

const requestMonthlyFee = movingFees => (dispatch, getState) => {
    const currentState = getState().mortgageRequestMovingExpenses;
    const mortgageRequestMortgageData = getState().mortgageRequestMortgageData;

    const mortgageCost = mortgageRequestMortgageData.getIn(['data', 'importeHipoteca']);
    const isAlreadyFetching = currentState.get('isFetching');

    const queryParams = {
        query: {
            'mortgage-amount': mortgageCost,
            'expenses-amount': movingFees
        }
    }

    if (!isAlreadyFetching) {

        dispatch(requestMonthlyFeeInProgress());
        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestCalculateMonthlyFee',
            params: queryParams
        })
            .then(response => dispatch(requestMonthlyFeeSuccess(response['data'])))
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestMonthlyFeeFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const acceptMovingFee = (expenseValue, history) => dispatch => {
    const queryParams = {
        query: {
            expenseValue
        }
    };

    dispatch(acceptMovingFeeInProgress());
    return APIPost({
        dispatch,
        endpoint: 'mortgageRequestAcceptMovingFee',
        params: queryParams
    })
        .then(() => {
            dispatch(acceptMovingFeeSuccess());
            dispatch(requestMortgageData());
            dispatch(requestState('/myprofile/mortgage/moving-expenses-success', history));
        })
        .catch(() => {
            dispatch(acceptMovingFeeFailure());
            history.push('/myprofile/mortgage-error');
        })
}

const cancelMovingExpensesCurrentOffer = (history) => dispatch => {

    return APIPost({
        dispatch,
        endpoint: 'mortgageRequestCancelMovingExpensesCurrentOffer'
    })
        .then(() => {
            history.push('/myprofile/mortgage/moving-expenses');
        })
        .catch(() => {
            history.push('/myprofile/mortgage-error');
        })
}

module.exports = {
    requestMonthlyFee,
    acceptMovingFee,
    cancelMovingExpensesCurrentOffer
};
